import { communicationService, utils } from '@wikia/ad-engine';
import { PLATFORM_EXPLORE_NAVIGATION_TOGGLE } from '../../../communication/events/events-platform-explore-navigation-toggle';

const initialOpenedRailClassName = 'current-wiki-tab-open';
const minimumWindowWidth = 1640;

export class ExploreNavigationHandler {
	async init(): Promise<void> {
		await this.waitForExploreNavigationOnPageLoad()
			.until()
			.then(() => {
				this.setExploreNavigationListener();
				if (window.innerWidth >= minimumWindowWidth) {
					window.dispatchEvent(new Event('resize'));
				}
			});
	}

	private checkCssClassOnDom(): boolean {
		return document.documentElement.classList.contains(initialOpenedRailClassName);
	}

	private setExploreNavigationListener(): void {
		communicationService.on(
			PLATFORM_EXPLORE_NAVIGATION_TOGGLE,
			async () => {
				if (window.innerWidth >= minimumWindowWidth) {
					const interval = setInterval(() => {
						window.dispatchEvent(new CustomEvent('resize', { detail: 'self triggered' }));
					}, 20);
					setTimeout(() => {
						clearInterval(interval);
					}, 350);
				}
			},
			false,
		);
	}

	private waitForExploreNavigationOnPageLoad() {
		return new utils.WaitFor(() => this.checkCssClassOnDom(), 20, 0, 50);
	}
}

export const exploreNavigationHandler = new ExploreNavigationHandler();
